import { formattedDatePtBrDateOnly } from '@utils/dates/formattedDatePtBr'

/**
 * Formata o valor para exibição no formato dd/mm/yyyy.
 * Aceita ISO, yyyy-mm-dd ou já formatado.
 */
export const dateMask = (value: string | null | undefined): string => {
  if (value == null || String(value).trim() === '') return ''
  return formattedDatePtBrDateOnly(value) || String(value).trim()
}
